<template>
  <OwnOption>
    <span class="w-full flex-col gap-3 align-center">
      <PhPlusCircle size="24" />
      <OwnType :text="text" el="span" color="primary" variant="title-regular" />
    </span>
  </OwnOption>
</template>

<script lang="ts" setup>
import { PhPlusCircle } from '@phosphor-icons/vue'

import { OwnOption } from '@/ui/OwnOption'
import { OwnType } from '@/ui/OwnType'

defineProps<{
  text: string
}>()
</script>
